export const LOCALES = {
    es: 'es',
    en: 'en',
} as const;

export const ENVIRONMENTS = {
    local        : 'local',
    development  : 'development',
    preproduction: 'preproduction',
    production   : 'production',
} as const;
